import "./index.scss";
import App from "./App";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement as Element);

root.render(
  <Router>
    <App />
  </Router>
);
